import React from 'react';
import { Redirect } from 'react-router'
import '../css/App.css';
import Loading from "./Loading";

class Retry extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            loading: false,
            redirect : false,
            reload : false,
            text : props.text,
            url : props.url,
            btn : props.btn,
            type : props.type,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }
    render() {
        if(this.state.redirect)
            return (<Redirect to={this.state.url}/>);
        return (
            <div className="App">
                <div className="App-body bg-white">
                    <form onSubmit={this.handleSubmit}>
                        <div style={{marginTop:"30vmin",padding:"0 15px",fontSize:"20px"}}>
                            {this.state.text}
                        </div>
                        <input type={"submit"} className={"btn submitPhone"} value={"تلاش مجدد"}/>
                    </form>
                </div>
                <Loading loading={this.state.loading}/>
            </div>
        );
    }

    handleSubmit(event){
        event.preventDefault();
        if(this.state.type == "REDIRECT")
            this.setState({redirect:true});
        if(this.state.type == "RELOAD")
            window.location.reload();
    }
}



export default Retry;
